import './ChoiceList.css';
export default {
    "root": "ChoiceList_root__14kz4",
    "small": "ChoiceList_small__14kz4",
    "large": "ChoiceList_large__14kz4",
    "titleHidden": "ChoiceList_titleHidden__14kz4",
    "description": "ChoiceList_description__14kz4",
    "choices": "ChoiceList_choices__14kz4",
    "horizontal": "ChoiceList_horizontal__14kz4",
    "error": "ChoiceList_error__14kz4",
    "errorIcon": "ChoiceList_errorIcon__14kz4",
    "errorText": "ChoiceList_errorText__14kz4"
};
